// Detects whether the current request is on a unit's own custom domain
// rather than this app's own default host (scoutingops.com's site
// subdomain, a Heroku review/staging host, or local dev). Default public
// routing is by the org's own Clerk slug under this app's own host
// (/site/:slug) — a custom domain overrides that, resolving the whole
// origin to one specific unit's site instead.
const DEFAULT_HOSTNAME_DOMAINS = ["herokuapp.com", "scoutingops.com"];
const DEFAULT_HOSTNAMES = ["localhost", "127.0.0.1"];

// Exact match or a genuine subdomain (separated by a real "." boundary) —
// a plain `.endsWith(domain)` string check would wrongly treat something
// like "evilscoutingops.com" as our own "scoutingops.com" host, since the
// raw characters happen to match at the end without actually being a
// subdomain relationship.
function isOwnDomainOrSubdomain(hostname: string, domain: string): boolean {
  return hostname === domain || hostname.endsWith(`.${domain}`);
}

export function getCustomDomainHostname(hostname: string = window.location.hostname): string | null {
  if (DEFAULT_HOSTNAMES.includes(hostname)) return null;
  if (DEFAULT_HOSTNAME_DOMAINS.some((domain) => isOwnDomainOrSubdomain(hostname, domain))) return null;
  return hostname;
}
